import text from 'app/static/action/text'

export default {
  text,
}
